// extracted by mini-css-extract-plugin
export default {"containerbox":"headwithSubhead_containerbox__8JO2Z","Heading":"headwithSubhead_Heading__tmWg1","subHeading":"headwithSubhead_subHeading__+jTFa"};